import { FlipCard1, FlipCard2, FlipCard3, FlipCard4, VectorKeyService } from '@/assets';
import FlipCard from '@/components/pages/Home/FlipCard';
import React from 'react';
import { useTranslation } from 'react-i18next';

const SectionKeyServiceHighlight = () => {
  const { t } = useTranslation();
  return (
    <section className="key-service-highlight">
      <div className="title-section">
        <p className="title">{t('Key Service Highlight')}</p>
        <span className="tag">(04)</span>
      </div>
      <div className="layout-grid">
        <div className="grid-row">
          <FlipCard
            image={FlipCard1}
            title={t('Innovative Technology Solutions')}
            desc={[
              t('Blockchain Development'),
              t('AI and Machine Learning'),
              t('IoT Development Services'),
              t('Whitelabel Solutions'),
            ]}
            number="01"
            desc2={[
              {
                label: `${t('Blockchain Development')}: `,
                value: t(
                  'We create secure blockchain solutions, including smart contracts and DApps, empowering businesses with trust and efficiency.'
                ),
              },
              {
                label: `${t('AI and Machine Learning')}: `,
                value: t(
                  'Our AI solutions optimize operations with predictive analytics and personalized experiences.'
                ),
              },

              {
                label: `${t('IoT Development')}: `,
                value: t(
                  'We connect devices for real-time insights, developing custom applications for various sectors.'
                ),
              },
              {
                label: `${t('Whitelabel Solutions')}: `,
                value: t(
                  'Launch faster with our customizable software, allowing you to focus on growth.'
                ),
              },
            ]}
          />
        </div>
        <div className="grid-row">
          <FlipCard
            image={FlipCard2}
            title={t('Software Development Services')}
            desc={[
              t('Software Development'),
              t('Mobile App Development'),
              t('Web App Development'),
              t('Game Development'),
            ]}
            number="02"
            desc2={[
              {
                label: `${t('Software Development')}: `,
                value: t(
                  'We create software solutions that streamline operations. Our services ensure high performance.'
                ),
              },
              {
                label: `${t('Mobile App Development')}: `,
                value: t(
                  'Engage users with intuitive apps. We create cross-platform applications, ensuring great user experiences.'
                ),
              },
              {
                label: `${t('Web App Development')}: `,
                value: t(
                  'Our web applications are fast, secure, and user-friendly, built to meet your needs. We ensure robust functionality.'
                ),
              },
              {
                label: `${t('Game Development')}: `,
                value: t(
                  'Bring immersive gaming experiences to life. We craft engaging 2D/3D games for mobile, web and desktop.'
                ),
              },
            ]}
          />
        </div>
        <div className="grid-row">
          <FlipCard
            image={FlipCard3}
            title={t('Enterprise Solutions, Cloud & IT Services')}
            desc={[
              t('Cloud Migration'),
              t('CRM Services'),
              t('SAP Development'),
              t('System Design Audit'),
              t('QA And Testing'),
            ]}
            number="03"
            desc2={[
              {
                label: `${t('Cloud Migration')}: `,
                value: t(
                  'Transition to the cloud with our expert services, ensuring secure transfers to AWS, Azure, or Google Cloud.'
                ),
              },
              {
                label: `${t('CRM Services')}: `,
                value: t('Optimize customer relationships with tailored CRM solutions.'),
              },
              {
                label: `${t('SAP Development')}: `,
                value: t(`Unlock SAP's potential with our specialized services.`),
              },
              {
                label: `${t('System Design Audit')}: `,
                value: t('Ensure your cloud infrastructure is secure and efficient.'),
              },
              {
                label: `${t('QA And Testing')}: `,
                value: t('We guarantee high-quality software with our QA and testing services.'),
              },
            ]}
          />
          <FlipCard
            image={FlipCard4}
            title={t('Trading System Solutions')}
            desc={[t('AI Algorithms'), t('Monitor System'), t('Backtesting Methodology')]}
            number="04"
            desc2={[
              {
                label: `${t('AI Algorithms')}: `,
                value: t(
                  'Enhance trading strategies with AI algorithms. We develop models for predictive analytics, market trends, and automated decisions for smarter trades.'
                ),
              },
              {
                label: `${t('Monitor System')}: `,
                value: t(
                  'Stay ahead with real-time monitoring tools to track market data, portfolio performance, and system health for actionable insights.'
                ),
              },
              {
                label: `${t('Backtesting Methodology')}: `,
                value: t(
                  'Validate strategies with our backtesting frameworks to simulate historical data, refining strategies and minimizing risks.'
                ),
              },
            ]}
          />
        </div>
      </div>
      <div className="vector-key-service">
        <VectorKeyService />
      </div>
    </section>
  );
};

export default React.memo(SectionKeyServiceHighlight);
